export const filterEmptyParams = function <T extends Record<string, unknown>>(
  obj: T
): Partial<T> {
  const result: Partial<T> = {};

  for (const key of Object.keys(obj) as Array<keyof T>) {
    const value = obj[key];

    // Exclude empty strings, null, or undefined
    if (value === '' || value === null || value === undefined) continue;

    // Exclude empty arrays
    if (Array.isArray(value) && value.length === 0) continue;

    // Exclude empty objects
    if (
      typeof value === 'object' &&
      !Array.isArray(value) &&
      Object.keys(value as Record<string, unknown>).length === 0
    )
      continue;

    // Keep valid fields
    result[key] = value;
  }

  return result;
};
